import { render } from "./StatuspagesIndex.vue?vue&type=template&id=1fe9f7ce"
import script from "./StatuspagesIndex.vue?vue&type=script&lang=js"
export * from "./StatuspagesIndex.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__